'use strict';

angular.module('shiftTraderApp')
  .controller('CreateWorkPeriodDialogCtrl', function ($scope, $timeout, WorkPeriods, Session, params, $uibModalInstance,
                                                      toastr, $rootScope, $filter, TimeService, ShepherdTourService,
                                                      $log, $interval, $controller, UsersPositions, SAErrorHandler) {

    var baseCtrl = $controller('BaseSmartCWPCtrl', {$scope: $scope, params: params});

    $scope.allUsers = lodash.each($scope.allUsers, function(u) {
      u._scheduledToWork = false;
    });

    $scope.nowInStoreTime = TimeService.getNowInStoreTime();
    $scope.dateToday = TimeService.momentToDateInLocalOffset($scope.nowInStoreTime, true, true, true);
    $scope.mode = params.mode;

    angular.extend($scope.state, {
      mode: params.mode,
      submittingRequest: false,
      q: {
        isDuplicate: function() {
          return params.mode === 'duplicate';
        },
        isEdit: function() {
          return params.mode === 'edit';
        },
        isCreate: function() {
          return params.mode === 'create';
        }
      }
    });

    // even though we'll always be working with WorkPeriods, calling it currentShift to match smartScheduling derived controller
    $scope.currentShift = undefined;

    $scope.startOfWeekDay = Session.getStartOfWeekDay();
    var enableEndDateWatch = false;
    var formDataInitCompleted = false;

    $scope.datePickerOptions = {
      startingDay: $scope.startOfWeekDay,
      minDate: $scope.dateToday,
      showWeeks: false
    };

    $scope.datepickers = {
      startDateOpened: false,
      endDateOpened: false
    };

    $scope.openStartDate = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      if ($scope.datepickers.startDateOpened === true) {
        $scope.datepickers.startDateOpened = false;
      } else {
        $scope.datepickers.startDateOpened = true;
      }
    };

    $scope.openEndDate = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      if ($scope.datepickers.endDateOpened === true) {
        $scope.datepickers.endDateOpened = false;
      } else {
        $scope.datepickers.endDateOpened = true;
      }
    };

    //deal with preloading of workPeriod, positions, selected users, etc
    if ($scope.state.q.isEdit()) {
      $scope.currentShift = WorkPeriods.initWithData(lodash.clone(params.workPeriod));
      $scope.thePosition = $scope.currentShift.position;
    }

    if ($scope.state.q.isDuplicate()) {
      $scope.currentShift = WorkPeriods.initWithData(lodash.clone(params.workPeriod));
      $scope.currentShift.user = null;
      $scope.currentShift.user_id = undefined;
      $scope.currentShift.published_by = null;
      $scope.currentShift.published_by_id = null;
      $scope.currentShift.published_at = null;

      $scope.originalShift = WorkPeriods.initWithData(lodash.clone(params.workPeriod));

      $scope.thePosition = $scope.currentShift.position;
    }


    $scope.positionGroupByFn = function(pos) {
      var idx = lodash.findIndex($scope.allDepartments, {id: pos.department_id});

      if (idx > -1) {
        return $scope.allDepartments[idx].name;
      } else {
        return '';
      }
    };

    var originalUserId;
    if ($scope.state.q.isEdit()) {
      // if this workPeriod already has a user assigned then show it as such
      var idx = lodash.findIndex($scope.allUsers, function(u) {
        return $scope.currentShift.$isAssigned() && u.id === $scope.currentShift.user.id;
      });

      if (idx > -1) {
        $scope.allUsers[idx]._scheduledToWork = true;
        originalUserId = $scope.allUsers[idx].id;
        $rootScope.$broadcast('sa:employeeSelectedForInfo', $scope.allUsers[idx]);
      }

      $scope.originalShift = WorkPeriods.initWithData(lodash.clone($scope.currentShift));
    }




    var startTime, startDate, endTime, endDate;
    // deal with ramifications of start time here
    if ($scope.state.q.isCreate()) {
      $scope.thePosition = params.position;

      $scope.currentShift = {};
      $scope.currentShift.position_id = $scope.thePosition.id;
      $scope.currentShift.position = $scope.thePosition;

      startDate = TimeService.momentToDateInLocalOffset(params.currentDate);
      endDate = TimeService.momentToDateInLocalOffset(params.currentDate);

      if ($scope.nowInStoreTime.isSame(moment.utc(params.currentDate.toDate()).tz(Session.getTimezone()), 'day')) {
        startTime = moment().tz(Session.getTimezone()).add(1, 'hours').minutes(0).toDate();
        endTime = moment().tz(Session.getTimezone()).add(2, 'hours').minutes(0).toDate();
      } else {
        startTime = moment().week(26).minutes(0).hours(6).milliseconds(0).seconds(0).toDate();
        endTime = moment().week(26).minutes(0).hours(16).milliseconds(0).seconds(0).toDate();
      }

    } else { // duplicate or edit presets the time

      // just in case position isn't in $scope.allPositions, let's tack it on
      if (lodash.findIndex($scope.allPositions, {id: $scope.currentShift.position.id}) === -1) {
        $scope.allPositions.push($scope.currentShift.position);
      }

      //in the case that this is an edit, preload that information into the form elements
      startTime = moment().week(26).hours($scope.currentShift.start_time.hours()).minutes($scope.currentShift.start_time.minutes()).milliseconds(0).seconds(0).toDate();
      endTime = moment().week(26).hours($scope.currentShift.end_time.hours()).minutes($scope.currentShift.end_time.minutes()).milliseconds(0).seconds(0).toDate();

      // have to subtract the timezone offset of the organization so that the date object treats it properly
      startDate = moment($scope.currentShift.start_time).subtract($scope.currentShift.start_time._offset, 'minutes').toDate();
      endDate = moment($scope.currentShift.end_time).subtract($scope.currentShift.start_time._offset, 'minutes').toDate();

      $scope.originalStartTime = moment($scope.currentShift.start_time);
      $scope.originalEndTime = moment($scope.currentShift.end_time);

      $scope.weekRange = TimeService.getWeekTwixFromMoment($scope.originalStartTime, 0, 0, false);
      $scope.adjustedWeekRange = TimeService.getWeekTwixFromMoment($scope.originalStartTime, 0, 0, true);
    }

    // only allow active positions (to populate select properly)
    // if current shift is inactive position, then tack that onto the list
    $scope.allPositions = lodash.filter($scope.allPositions, function(pos) {
      return pos.active || pos.id === $scope.currentShift.position_id;
    });

    $scope.formData = {
      startDate: startDate,
      startTime: startTime,
      endDate: endDate,
      endTime: endTime,
      selectedUser: undefined,
      selectedPosition: undefined,
      organization_id: Session.getCurrentOrgId(),
      created_by: $scope.me.id,
      positionId: $scope.thePosition.id
    };

    formDataInitCompleted = true;

    $scope.close = function() {
      baseCtrl.clearOutUninitializedUsersPositions();

      $scope.allUsers = lodash.each($scope.allUsers, function(u) {
        u._scheduledToWork = undefined;
      });
      $uibModalInstance.dismiss();
    };

    var setWatchId = function() {
      $scope.currentShift._watchId = $scope.currentShift.start_time.unix() + '-' + $scope.currentShift.end_time.unix() + '-' + $scope.currentShift.position_id;
    };

    var processDates = function() {
      //$log.log('processDates called', moment.utc().unix());
      var data, start_time, end_time, tzOffsetInMinutes;
      try {
        if (lodash.isNull($scope.formData.startTime)) {
          if ($scope.nowInStoreTime.isSame(moment.utc(params.currentDate.toDate()).tz(Session.getTimezone()), 'day')) {
            $scope.formData.startTime = moment().tz(Session.getTimezone()).add(1, 'hours').minutes(0).toDate();
          } else {
            $scope.formData.startTime = moment().week(26).minutes(0).hours(6).milliseconds(0).seconds(0).toDate();
          }
        }

        if (lodash.isNull($scope.formData.endTime)) {
          if ($scope.nowInStoreTime.isSame(moment.utc(params.currentDate.toDate()).tz(Session.getTimezone()), 'day')) {
            $scope.formData.endTime = moment().tz(Session.getTimezone()).add(2, 'hours').minutes(0).toDate();
          } else {
            $scope.formData.endTime = moment().week(26).minutes(0).hours(16).milliseconds(0).seconds(0).toDate();
          }
        }

        tzOffsetInMinutes = moment($scope.formData.startDate).tz(Session.getTimezone())._offset;
        start_time = moment($scope.formData.startDate).tz(Session.getTimezone()).add(tzOffsetInMinutes, 'minutes');
        start_time.hour($scope.formData.startTime.getHours()).minute($scope.formData.startTime.getMinutes());
        tzOffsetInMinutes = moment($scope.formData.endDate).tz(Session.getTimezone())._offset;
        end_time = moment($scope.formData.endDate).tz(Session.getTimezone()).add(tzOffsetInMinutes, 'minutes');
        end_time.hour($scope.formData.endTime.getHours()).minute($scope.formData.endTime.getMinutes());

        data = {
          raw: {
            start_time: start_time,
            end_time: end_time
          }
        };

        // if the day of year has changed, then reset the weekRange
        if ($scope.currentShift && $scope.currentShift.start_time && $scope.currentShift.end_time &&
          (data.raw.start_time.dayOfYear() !== $scope.currentShift.start_time.dayOfYear() ||
          data.raw.end_time.dayOfYear() !== $scope.currentShift.end_time.dayOfYear())) {

          $scope.weekRange = TimeService.getWeekTwixFromMoment(data.raw.start_time, 0, 0, false);
          $scope.adjustedWeekRange = TimeService.getWeekTwixFromMoment(data.raw.end_time, 0, 0, true);
        }


        $scope.currentShift._type = 'workPeriod';
        $scope.currentShift.start_time = data.raw.start_time;
        $scope.currentShift.end_time = data.raw.end_time;
        $scope.currentShift.published_by_id = null;
        $scope.currentShift.range_twix = $scope.currentShift.start_time.twix($scope.currentShift.end_time);
        $scope.currentShift.$isShift = function() {
          return false;
        };

        $scope.currentShift.$isWorkPeriod = function() {
          return false;
        };

        //$scope.currentShift.position = $scope.thePosition;
        //$scope.currentShift.position_id = $scope.thePosition.id;
        //setWatchId();

      } catch (e) {
        console.log(e);
        var errorData = {
          createWorkPeriodDialogData: {
            raw_start_date: $scope.formData.startDate,
            raw_end_date: $scope.formData.endDate,
            raw_start_time: $scope.formData.startTime,
            raw_end_time: $scope.formData.endTime,
            params_mode: $scope.state.mode,
            dateToday: $scope.dateToday,
            nowInStoreTime: $scope.nowInStoreTime.format(),
            tzOffsetInMinutes: tzOffsetInMinutes,
            me: {
              id: $scope.me.id,
              name: $scope.me.name
            }
          }
        };

        if (params.workPeriod) {
          errorData.workPeriod = {
            id: $scope.currentShift.id,
            position_id: $scope.currentShift.position_id,
            user_id: $scope.currentShift.user_id,
            start_time: $scope.currentShift.start_time.format(),
            end_time: $scope.currentShift.end_time.format()
          };
        } else {
          errorData.workPeriod = {
            id: null,
            position_id: params.position.id,
            position_name: params.position.name
          }
        }

        Rollbar.error(e, errorData);
      }
      return data;
    };

    baseCtrl.calcAndSetUserLists($scope.thePosition.id);
    $scope.processedDates = processDates();
    setWatchId();
    $scope.formDataTimeoutRunning = false;

    $scope.$watch('formData', function () {
      // use timeouts to prevent the processDates() from being run on EVERY click of the date/time picker
      // if the timeout is running and the watch triggers, cancel it.  Afterwards, restart it.
      // when the timeout elapses then re-run processDates()
      if ($scope.formDataTimeoutRunning) {
        $timeout.cancel($scope.formDataTimeout);
      }

      $scope.formDataTimeout = $timeout(function() {
        var newDates = processDates();
        var oldPositionId = $scope.currentShift.position_id;

        if (parseInt($scope.formData.positionId) !== oldPositionId) {
          var idx = lodash.findIndex($scope.allPositions, {id: $scope.formData.positionId});
          if (idx > -1) {
            $scope.thePosition = $scope.allPositions[idx];
            $scope.currentShift.position_id = $scope.thePosition.id;
            $scope.currentShift.position = $scope.allPositions[idx];
            baseCtrl.calcAndSetUserLists($scope.currentShift.position_id);

            // check if user that is currently assigned actually has this position
            var assignedUser = lodash.find($scope.allUsers, {'_scheduledToWork': true});

            if (!lodash.isUndefined(assignedUser)) {
              // check if assignedUser.id matches anything in $scope.userListWithPosition
              if (!lodash.some($scope.userListWithPosition, function(u) {
                  return assignedUser.id === u.id;
                })) {
                assignedUser._scheduledToWork = false;
                $scope.currentShift.user = null;
                $scope.currentShift.user_id = null;
                baseCtrl.broadcastCalcLoadFinished();
              }
            }
          }
        }

        if (!$scope.processedDates.raw.start_time.isSame(newDates.raw.start_time) || !$scope.processedDates.raw.end_time.isSame(newDates.raw.end_time)) {
        }

        setWatchId();

        if (lodash.every(selectedDatesAreValid(newDates.raw.start_time, newDates.raw.end_time))) {
          //console.log('theyre valid. processing dates.');
          $scope.processedDates = newDates;
        }

        $scope.formDataTimeoutRunning = false;
        //console.log('timeout elapsed');
      }, 450);
      $scope.formDataTimeoutRunning = true;
    }, angular.equals);

    $scope.$watch('formData.startDate', function(startDate, oldDate) {
      //console.log(startDate);
      //console.log(oldDate);
      if (enableEndDateWatch && startDate !== oldDate) {
        //console.log('WATCH: formData.startDate');
        $scope.formData.endDate = startDate;
      }
    });
//
//    $scope.$watch('formData.startTime', function() {
//      if ($scope.processedDates.raw.start_time.isAfter($scope.processedDates.raw.end_time)) {
//        //TODO: figure out why this increments one hour too soon
//        $scope.formData.endTime = moment($scope.processedDates.raw.start_time).add('hours',1).toDate();
//      }
//    });

    baseCtrl.broadcastCalcLoadFinished = function() {
      if ($scope.state.q.isEdit() && lodash.some($scope.allUsers, function(u) {
          return u._scheduledToWork;
        })) {
        $rootScope.$broadcast('sa:cwpLoadFinished', lodash.find($scope.allUsers, {'_scheduledToWork': true}));
      } else {
        $rootScope.$broadcast('sa:cwpLoadFinished', $filter('orderBy')($scope.userListWithPosition, ['availabilityIndex', 'id'])[0]);
      }
    };


    var selectedDatesAreValid = function(start, end) {
      var result = {};
      result.start_before_end = start.isBefore(end);
      result.start_after_now = start.isAfter($scope.nowInStoreTime);
      result.has_length = start.twix(end).length('minutes') > 0;
      return result;
    };

    $scope.validateForm = function() {
      var newDates = processDates();
      var result = selectedDatesAreValid(newDates.raw.start_time, newDates.raw.end_time);
      var employeesSelected = null;
      if ($scope.state.q.isCreate() || $scope.state.q.isDuplicate()) {
        employeesSelected = lodash.filter($scope.allUsers, {_scheduledToWork:true}).length > 0;
      } else { // 'edit' case
        employeesSelected = lodash.filter($scope.allUsers, {_scheduledToWork:true}).length === 1;
      }

      return {
        valid: lodash.every(lodash.map(result, function(x) { return x === true; }), function(val) { return val; }),
        required: result,
        optional: {
          employees_selected: employeesSelected
        }
      }
    };

    $scope.formIsValid = function() {
      if (formDataInitCompleted) {
        $scope.latestFormValidation = $scope.validateForm();
        return $scope.latestFormValidation.valid;
      } else {
        return false;
      }
    };

    var submitEditWorkPeriod = function(user) {
      var giveCorrectCommunicationToastrMessage = function(wp) {
        if (wp.$isPublished()) {
          // check if an SMS will be sent for this shift
          if (wp.start_time.isBefore(TimeService.getNowInStoreTime().add({hours: 23, minutes: 59}))) {
            console.log('within 24 hrs!');
            toastr.success('Edited successfully. Shift Agent attempted to deliver an email and text message to ' + wp.user.name + '.', 'Success');
          } else {
            toastr.success('Edited successfully. Shift Agent attempted to deliver an email to ' + wp.user.name + '.', 'Success');
          }
        }
      };

      var newData = {};
      $scope.processedDates = processDates();
      newData.start_time = $scope.processedDates.raw.start_time.utc().format();
      newData.end_time = $scope.processedDates.raw.end_time.utc().format();
      newData.organization_id = lodash.isUndefined($scope.currentShift.organization_id) ? $scope.currentShift.organization.id : $scope.currentShift.organization_id;
      newData.position_id = $scope.currentShift.position_id;
      if (!lodash.isUndefined(user)) {
        newData.user_id = user.id;
      } else {
        newData.user_id = null;
      }

      if ($scope.originalShift.$isPublished() && !lodash.isNull(newData.user_id)) {
        newData.published_by_id = $scope.me.id;
      }

      var userHasChanged = !lodash.isUndefined($scope.originalShift) && !lodash.isNull($scope.originalShift)
                            && !lodash.isUndefined($scope.originalShift.user) && !lodash.isNull($scope.originalShift.user)
                            && newData.user_id !== $scope.originalShift.user.id;
      var startDayHasChanged = $scope.processedDates.raw.start_time.day() !== $scope.originalShift.start_time.day();

      if (!startDayHasChanged && !$scope.originalShift.$isPublished()) {
        // this is just a standard time change. Just change the start, end times.

        $scope.currentShift.$update(newData)
          .then(function(respData) {
            giveCorrectCommunicationToastrMessage(respData);
            $uibModalInstance.close([respData]);
          }, function() {
            $scope.state.submittingRequest = true

            // TODO: use SAErrorHandler and enhanced API error handling to make this more robust
            toastr.error('There was a problem trying to edit this shift. Please try again later.', 'Error');
          });
      } else {
        // either the start day has changed or the user has changed.
        // either way, we need to send a cancelled shift to the old/current employee and a new published shift to the next

        $scope.currentShift.$update({active: false})
          .then(function(respData) {
            WorkPeriods.create(newData)
              .then(function(wp) {
                giveCorrectCommunicationToastrMessage(wp);
                $uibModalInstance.close([respData, wp]);
              }, function() {
                $scope.state.submittingRequest = true
                // TODO: use SAErrorHandler and enhanced API error handling to make this more robust
                toastr.error('There was a problem trying to edit this shift. Please try again later.', 'Error');
              });
          }, function() {
            $scope.state.submittingRequest = true
            toastr.error('There was a problem trying to edit this shift. Please try again later.', 'Error');
            // TODO: use SAErrorHandler and enhanced API error handling to make this more robust
          });

      }
    };

    var createWorkPeriod = function(user) {
      var data = {};    //get the dates
      data.start_time = $scope.processedDates.raw.start_time.utc().format();
      data.end_time = $scope.processedDates.raw.end_time.utc().format();
      data.organization_id = Session.getCurrentOrgId();
      data.position_id = $scope.thePosition.id;
      if(!lodash.isUndefined(user)) {
        data.user_id = user.id;
      }

      WorkPeriods.create(data)
        .then(function(wp) {
          //console.log('work period created ' + wp.user.id);

          $uibModalInstance.close([wp]);
        }, function(response) {
          $scope.state.submittingRequest = true
          SAErrorHandler.processError(response);
        });
    };

    $scope.submitTheForm = function() {
      if ($scope.state.submittingRequest) {
        return
      }

      $scope.state.submittingRequest = true
      var user = lodash.find($scope.allUsers, {_scheduledToWork: true});

      // if user has a users_position with id:null, let's create it

      var exec = function() {
        if ($scope.state.q.isCreate() || $scope.state.q.isDuplicate()) {
          createWorkPeriod(user);
        } else { // 'edit' case
          submitEditWorkPeriod(user);
        }
      };

      if (user && lodash.some(user.users_positions, function(up) {
          return lodash.isNull(up.id);
        })) {
        var up = lodash.find(user.users_positions, {position_id: $scope.currentShift.position_id, id: null});
        var upClone = lodash.cloneDeep(up);

        delete upClone.id;
        UsersPositions.create(upClone)
          .then(function(newUp) {
            //console.log('new users_position', newUp);

            if (lodash.has($scope.state.writeIn.usersPositionAdditions, user.id)) {
              var idx = lodash.indexOf($scope.state.writeIn.usersPositionAdditions[user.id], upClone.position_id);
              if (idx > -1) {
                $scope.state.writeIn.usersPositionAdditions[user.id].splice(idx, 1);
              }
            }

            up.id = newUp.id;
            up.position = lodash.find($scope.allPositions, {id: newUp.position_id});
            exec();
            $scope.state.writeIn.showInput = false;
          }, function() {
            $scope.state.submittingRequest = true
            console.log('issue adding users_position')
          });
      } else {
        exec();
      }
    };

    $scope.$on('addUserToShift', function(event, user) {
      $log.log('EVENT SEEN: addUserToShift', user.name);
      event.stopPropagation();

      var idx = lodash.findIndex($scope.allUsers, {id: user.id});

      lodash.each($scope.allUsers, function(u, idy) {
        $scope.allUsers[idy]._scheduledToWork = (idx === idy);
      });

      $scope.currentShift.user = $scope.allUsers[idx];
      $scope.currentShift.user_id = $scope.allUsers[idx].id;

      $scope.$broadcast('sa:checkShiftAssignments');
      $rootScope.$broadcast('sa:cwpLoadFinished', $scope.allUsers[idx]);

    });

    $scope.$on('unassignUserFromShift', function(event) {
      $log.log('EVENT SEEN: unassignUserFromShift');
      event.stopPropagation();

      lodash.each($scope.allUsers, function(u, idy) {
        $scope.allUsers[idy]._scheduledToWork = false;
      });

      $scope.currentShift.user = null
      $scope.currentShift.user_id = null;

      $scope.$broadcast('sa:checkShiftAssignments');
    });

    enableEndDateWatch = true;

    ShepherdTourService.triggerEvent('cwpOpenedSuccessfully', 500);
  });
